module.exports = __webpack_public_path__ + "img/back3.5bec1ba3.png";